import $ from 'jquery';
import barba from '@barba/core';
import { gsap } from 'gsap';

import { disableBodyScroll, elementPosition, enableBodyScroll, isTouchScreen, lenis, replaceBodyClasses, scrollPosition, smoothScrollTo, wait } from '../global/helpers';
import { $Elements, BarbaLinks, BaseLinks, Breakpoints, Classes, Durations, Elements, Events, resetAnimations, ShopLinks } from '../global/constants';
import { initBaseTransistions } from './default';

// ---------- Barba Initialisation ----------

if(document.body.classList.contains('woocommerce-page') && !document.body.classList.contains('post-type-archive-product')) {
	initBaseTransistions(BaseLinks);
}
else {

	barba.init({
		debug: false,
		timeout: 10000,
		preventRunning: true,
		prevent: ({ el }) => !$(el).is(BarbaLinks),
		transitions: [{
			sync: true,
			once: async() => $Elements.window.on('load', pageLoaded),
			enter: async() => $Elements.document.one(Events.page.transition, pageLoaded),
			leave: async(data) => {

				Elements.LoadingBar.classList.add(Classes.loading);
				document.body.classList.add(Classes.leaving);
				data.current.container.classList.add(Classes.leaving);

				if(isMenuLink(data)) {
					await menuTransition(data);
				}
				else {
					await defaultTransition(data);
				}

				return true;
			},
			after: async(data) => {

				lenis.scrollTo(0, { immediate: true });

				replaceBodyClasses(data.next);

				$('.' + Classes.transitionClone).remove();

				$Elements.document.trigger(Events.page.transition);

				return true;
			}
		}]
	});

	initBaseTransistions(ShopLinks, false);
}

// ---------- Global ----------

async function pageLoaded() {

	resetAnimations();
	$Elements.document.trigger(Events.page.enter);
	Elements.MainWrapper.classList.remove(Classes.loading, Classes.initialLoad);
	Elements.LoadingBar.classList.remove(Classes.loading);
	Elements.LoadingOverlay.classList.remove(Classes.loading);
	$('.hero-section').addClass(Classes.active);

	return true;
}

// ---------- Default Transition ----------

async function defaultTransition(data) {

	disableBodyScroll();

	Elements.LoadingOverlay.classList.add(Classes.loading);
	data.current.container.classList.add(Classes.leaving);

	await wait(Durations.page.ms / 3);

	const scroll = scrollPosition();

	gsap.set(data.current.container, {
		top: -scroll.scrollTop,
	});

	smoothScrollTo(0, 0, 0);

	if(document.body.classList.contains(Classes.menuOpen)) {
		document.body.classList.remove(Classes.menuOpen);
	}

	await wait(Durations.page.ms / 3);

	enableBodyScroll();

	return true;
}

// ---------- Menu Transition ----------

function isMenuLink(data) {
	return (typeof data.trigger !== 'string' && data.trigger.classList.contains('menu-link'));
}

async function menuTransition(data) {

	if(!isTouchScreen()) {

		disableBodyScroll();

		data.current.container.classList.add(Classes.leaving);

		await wait(Durations.page.ms / 2);

		const clone = Elements.MenuWrapper.querySelector('.hero-column.active');
		const nextHero = data.next.container.querySelector('.hero-section .section-columns .hero-column');

		document.body.appendChild(clone);
		clone.classList.add(Classes.transitionClone);
		clone.removeAttribute('id');
		document.body.classList.remove(Classes.menuOpen);

		await wait(Durations.page.ms / 2);

		data.current.container.classList.add(Classes.hidden);

		smoothScrollTo(0, 0, 0);

		await wait(50);

		nextHero.replaceWith(clone);

		await wait(50);

		clone.classList.remove(Classes.transitionClone);

		await wait(50);

		clone.classList.remove('in-menu');

		enableBodyScroll();
	}
	else {
		await defaultTransition(data);
	}

	return true;
}
